import axios from "axios";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { encryptRequest, decryptRequest } from "../utils/crypt";


const LogActivity = async ({ activity, type, email, ...args }) => {
  let result = await axios
    .post(`https://godrej.app-assertai.com:5000/Users/userActivity`, {
      activity,
      type: type,
      email: email,
      args,
    })
    .then((res) => {
      console.log("USER ACTIVITY LOGGED------> ");
    })
    .catch((err) => {
      console.log("CAUGHT ERROR WHILE USER ACTIVITY LOGGED------> ", err);
    });
};

const sessionFetch = async (token) => {
  var decoded = jwt_decode(token);
  let { data } = decoded;
  let emailOfUser = "";
  let decryptedResponse = await decryptRequest(data);

  let { email, lastLoginTime } = JSON.parse(decryptedResponse);
  LogActivity({
    activity: [{ workDone: "Login Done" }],
    type: "SignIn button Clicked",
    email: email,
    lastLoginTime,
  });
};

const loginFetch = async ({ email, password }) => {
  try {
    let { data, status } = await axios.post(
      `https://godrej.app-assertai.com:5000/Auth/login`,
      {
        email,
        password,
      }
    );
    // Assuming `data.data` is encrypted and needs to be decrypted
    let decryptedResponse = await decryptRequest(data.data);
    let parsedData = JSON.parse(decryptedResponse);

    // Storing the token in localStorage
    localStorage.setItem("token", parsedData.data);

    return status; // Return the status code for further handling in the component
  } catch (error) {
    // Handle the error and return useful error information
    // Check if the error response exists and is a 404 or any other status
    if (error.response) {
      const { status, data } = error.response;
      if (status === 404) {
        return {
          status: 404,
          message: data.message,
        };
      } else if (status === 401) {
        return {
          status: 401,
          message: "Unauthorized. Incorrect email or password.",
        };
      } else {
        return {
          status: status,
          message: data.message || "An unknown error occurred.",
        };
      }
    } else {
      return { status: 500, message: "Server error. Please try again later." };
    }
  }
};

const ssologinFetch = async ({ ssoToken }) => {
  try {
    let { data, status } = await axios.post(
      `https://godrej.app-assertai.com:5000/Auth/loginwithsso`,
      {
        ssoToken,
      }
    );
    // Assuming `data.data` is encrypted and needs to be decrypted
    let decryptedResponse = await decryptRequest(data.data);
    let parsedData = JSON.parse(decryptedResponse);
    console.log(
      "Parsed Data for SSO Login -----> ",
      parsedData,
      data,
      decryptedResponse
    );

    // Storing the token in localStorage
    localStorage.setItem("token", parsedData.data);

    return status; // Return the status code for further handling in the component
  } catch (error) {
    // Handle the error and return useful error information
    // Check if the error response exists and is a 404 or any other status
    if (error.response) {
      const { status, data } = error.response;
      if (status === 404) {
        return {
          status: 404,
          message: data.message,
        };
      } else if (status === 401) {
        return {
          status: 401,
          message: "Unauthorized. Incorrect email or password.",
        };
      } else {
        return {
          status: status,
          message: data.message || "An unknown error occurred.",
        };
      }
    } else {
      return { status: 500, message: "Server error. Please try again later." };
    }
  }
};

const signUpFetch = async ({
  newUserName,
  newUserEmail,
  newUserPassword,
  accessValueForNewUser,
  locationTypeSelected,
}) => {
  let result = await axios
    .post(`https://godrej.app-assertai.com:5000/Auth/signup`, {
      name: newUserName,
      email: newUserEmail,
      password: newUserPassword,
      userType: accessValueForNewUser,
      locationType: locationTypeSelected,
    })
    .then((res) => {
      return res.data.status;
    })
    .catch((err) => {
      return {
        message: err.response.data.message,
        status: err.response.data.status,
      };
    });
  return result;
};

export { loginFetch, signUpFetch, LogActivity, ssologinFetch };
